import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmbedScriptService {
  private activeScriptUrl?: string;
  private activeScript?: HTMLScriptElement;

  constructor() {}

  /** Load the given embed script, skipping only when it is already active. */
  loadEmbedScript(scriptUrl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.activeScriptUrl === scriptUrl) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.defer = true;
      script.dataset['prismeEmbed'] = '';

      script.onload = () => {
        this.activeScript?.remove();
        this.activeScript = script;
        this.activeScriptUrl = scriptUrl;
        console.log(`Embed script loaded from: ${scriptUrl}`);
        resolve();
      };

      script.onerror = () => {
        script.remove();
        console.error(`Failed to load embed script from: ${scriptUrl}`);
        reject(new Error(`Failed to load embed script from: ${scriptUrl}`));
      };

      document.head.appendChild(script);
    });
  }
}
